export class Usuario {
    id: number;
    activo: boolean;
    correoElectronico: string;
    fechaCreacion: string;
    primerApellido: string;
    primerNombre: string;
    segundoApellido: string;
    segundoNombre: string;
    usuario: string;
    roles: string[] = [];
}
